import { GET_TOC_PERKS } from '../../../../models/table-of-contents/queries.gql';
import useTableOfContents from '../../../../cms/utils/use-table-of-contents';

const useNavigationPerks = ({ skip }: { skip: boolean } = { skip: false }) =>
  useTableOfContents({
    query: GET_TOC_PERKS,
    skip,
    slug: 'perks',
    typename: 'MemberPerk',
  });

export default useNavigationPerks;
